import React, {useEffect, useRef, useState} from 'react';
import DropdownFocus from './dropdownFocus';
import { DropdownWrapper } from './styles';
import {ChevronDown} from "../../assets/icons/ChevronDown";
import {ChevronUp} from "../../assets/icons/ChevronUp";

export type DropdownItem = {
    name: string,
    key: string,
    link?: string,
    dataTrackId?: String,
    dataTrackClick?: String,
    onClick?: () => void,
    labelText?: string,
    id?: string,
}

type Props = {
    value?: string,
    items: Array<DropdownItem>,
    labelText?: string,
    id: string,
    placeholder?: string,
    onChange?: Function,
    dataTrackClick?: string,
    dataTrackId?: string,
}
 
const DropdownA11y = ({ value, items, labelText, id, placeholder = '', onChange, dataTrackClick, dataTrackId }: Props) => {
    const node = useRef<HTMLDivElement>(null);
    const itemsRef = useRef<(HTMLUListElement | null)[]>([])
    const [open, setOpen] = useState(false);
    const [focus, setFocus] = DropdownFocus(open, node, items.length, setOpen);

    const handleClick = (e: any) => {
        if (node.current && node.current.contains(e.target)) {
            return;
        }
        setOpen(false);
    };

    const handleChange = (item: any) => {
        if (onChange) {
            onChange(item.name);
            setOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClick);

        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);

    useEffect(() => {
        if (focus && itemsRef.current) {
            // @ts-ignore
            itemsRef.current[focus-1].focus();
        }
    }, [focus, itemsRef]);

    return (
        <DropdownWrapper ref={node}
             className={`${open? 'open' : 'close'}`}
             data-track-click={dataTrackClick}
             data-track-id={dataTrackId}
        >
            <button
                onClick={e => setOpen(!open)}
                aria-label={labelText}
                aria-expanded={open}
                id={id}>
                {value || items[0].name || placeholder}

                {!open && <ChevronDown />}
                {open &&  <ChevronUp />}

            </button>
            {open && (
                <ul
                    role="listbox"
                    aria-labelledby={id}
                >
                    {items.map( (item: DropdownItem, index:number) => {
                        return (
                                <li
                                    role="option"
                                    key={`dropdown-${index}`}
                                    ref={(el: any) => itemsRef.current[index] = el}
                                    onClick={ (e: any) => handleChange(item)}
                                    onKeyPress={ (e: any) => handleChange(item)}
                                    aria-selected={focus===index}
                                    tabIndex={0}
                                >
                                    {item.name}
                                </li>
                            );
                        }
                    )}
                </ul>
            )}
        </DropdownWrapper>
    );
};

export default DropdownA11y;
